import React from 'react';
import Media from 'react-media';

const fCClogo = '/img/questlogo.png';
const fCCglyph = '/img/questlogo.png';

function NavLogo() {
  return (
    <Media query='(min-width: 735px)'>
      {matches =>
        matches ? (
          <img
            alt='learn to code at QUEST logo'
            className='nav-logo logo'
            src={fCClogo}
          />
        ) : (
          <img
            alt='learn to code at QUEST logo'
            className='nav-logo logo'
            src={fCClogo}
          />
        )
      }
    </Media>
  );
}

NavLogo.displayName = 'NavLogo';

export default NavLogo;



// WEBPACK FOOTER //
// ./src/components/Header/components/NavLogo.js